import { Component, EventEmitter, Input, OnInit, Output, NgModule, AfterViewInit } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InboxDialogComponent } from '../components/inbox.dialog.component';
import { DataHelper } from '@helpers/data.helper';

@Component({
  selector: 'ticket-component',
  templateUrl: '../sharedTemplates/ticketdetail.component.html',
})
export class TicketDetailComponent implements OnInit, AfterViewInit {
  ticketid: number;
  subject: string;

  constructor(
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private route: ActivatedRoute,
    private _FormBuilder: UntypedFormBuilder,
    public dialog: MatDialog,
    public _DataHelper: DataHelper
  ) {
    this.route.params.subscribe(params => {
      this.ticketid = params['ticketid'];
      this.subject = params['subject'];

      ////console.log("ticketid", this.ticketid);
    });
  }

  ngOnInit() {
    this.getCustomerTicketDetail(this.ticketid);
  }

  ngAfterViewInit() {
    this._UiHelper.setLoadingDialog(false);
    this._UiHelper.setNavbarTitle('Message Detail', true);
  }

  getCustomerTicketDetail(ticketid) {
    this._ApiService.getCustomerTicketDetail(ticketid).then(CustomerTicketDetailList => {
      this._DataHelper.DataCustomerTicketDetailList = CustomerTicketDetailList;
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(InboxDialogComponent, {
      width: '300px',
      data: { data_ActivityCode: 4, data_TicketId: this.ticketid, data_Title: this.subject },
    });
  }
}
